export class ShowOrderService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/pedidos/getPedidoItens', { params })
  }
}
